export {getIsSharedEntry} from './get-is-shared-entry';
